import { useMemo } from 'react';

declare class ClipboardItem {
	constructor(data: { [mimeType: string]: Blob });
}

export interface SonarClipboardDataItem {
	data: Blob;
	mimeType: string;
}

type FullClipboard = Clipboard & {
	write(items: ClipboardItem[]): Promise<void>;
};

export type WrappedClipboard = Omit<FullClipboard, 'write'> & {
	write(items: SonarClipboardDataItem[]): Promise<void>;
};

const fullClipboard = window.navigator.clipboard as FullClipboard;

const write = (items: SonarClipboardDataItem[]) =>
	fullClipboard.write(items.map((item) => new ClipboardItem({ [ item.mimeType ]: item.data })));

const writeText = (data: string) => fullClipboard.writeText(data);

export function useClipboard(): FullClipboard {
	return useMemo(
		() =>
			({
				...fullClipboard,
				write: write,
				writeText: writeText
			} as FullClipboard),
		[]
	);
}
